import { Injectable, inject } from '@angular/core';
import { ServiceCategoriesRequestQuery } from '@app/src/app/modules/service/graphql/category/service.categories.request.query';
import { ServiceCategoryByRequestQuery } from '@app/src/app/modules/service/graphql/category/service.category.by.request.query';
import { ServiceCategoryRequestQuery } from '@app/src/app/modules/service/graphql/category/service.category.request.query';
import { ServiceCategoryExistsRequestQuery } from '@app/src/app/modules/service/graphql/category/service.category.exists.request.query';
import { ServiceCategoryRequestMutation } from '@app/src/app/modules/service/graphql/category/service.category.request.mutation';
import { ServiceCategoriesPublicRequestQuery } from '@app/src/app/modules/service/graphql/category/service.categories.public.request.query';
import {
  buildPayload,
  DashboardGlobalConfigType,
  ItemNotFound,
  OptionsType,
} from '@ckmk/angular';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ServiceCategoryService {
  public readonly list = inject(ServiceCategoriesRequestQuery);

  public readonly single = inject(ServiceCategoryRequestQuery);

  public readonly manage = inject(ServiceCategoryRequestMutation);

  public readonly exists = inject(ServiceCategoryExistsRequestQuery);

  public readonly category = inject(ServiceCategoryByRequestQuery);

  public readonly categories = inject(ServiceCategoriesPublicRequestQuery);

  public constructor() {}

  public async isExists(
    route: ActivatedRouteSnapshot,
    config?: DashboardGlobalConfigType,
  ): Promise<boolean> {
    return this.exists
      .fetchQuery(
        buildPayload()
          .into('payload', (pl) =>
            pl.filters((filter) => {
              if (config) {
                filter.equalTo('id', route.params['category']);
              } else {
                filter
                  .equalTo('active', true)
                  .equalTo('slug', route.params['category']);
              }
            }),
          )
          .build(),
      )
      .then((value) => !!value);
  }

  public async manageCategoriesOptions(search?: string): Promise<OptionsType> {
    return this.list
      .fetchQuery(
        buildPayload()
          .into('payload', (bd) => {
            bd.paginate(0).filters((filter) => filter.equalTo('active', true));

            if (search) {
              bd.search(search);
            }

            return bd;
          })
          .build() as any,
      )
      .then((res) => res?.result || [])
      .then((cats) =>
        cats.map(
          (cat) =>
            ({
              label: cat.title,
              value: cat.id,
              description: cat.shortDescription,
            }) as any,
        ),
      );
  }

  public async fetchBySlug(slug?: string | null) {
    return this.category
      .fetchQuery(this.buildSlugPayload(slug || '_no_slug_'))
      .then((res) => {
        if (res instanceof ItemNotFound) {
          return null;
        }

        return res;
      });
  }

  public watchBySlug(slug: string): void {
    this.category.watchQuery(this.buildSlugPayload(slug || '_no_slug_'));
  }

  protected buildSlugPayload(slug: string): any {
    return buildPayload()
      .into('payload', (builder) =>
        builder
          .setMultiple({
            includeCover: true,
          })
          .filters((filter) =>
            filter.equalTo('active', true).equalTo('slug', slug),
          ),
      )
      .build();
  }
}
